import apiSlice from "./apiSlice";

const projectHomeDetailsApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getProjectSummary: builder.query({
            query: (projectId) => ({
                url: `project/project-summary`,
                params: { projectId },
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["ProjectSummary"],
        }),
    }),
});

export const {
    useGetProjectSummaryQuery,
} = projectHomeDetailsApiSlice;
